import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  ChevronLeft,
  Plus,
} from 'react-bootstrap-icons';
import styles from './product_detail_view.module.css';
import { ActivityIcon, ActivityIconBlue, AIChatIcon2, AtollonIcon, EditIcon, FacebookIcon, GlobeIcon, LinkdinIcon, LockIcon, MessageIcon, MoreIcon, PhoneIcon, PrintIcon, SendIcon, ToolIcon, TrashIcon, TwitterIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Cell, Column, Content, Dialog, DialogTrigger, Divider, Flex, Grid, Item, Link, Menu, MenuTrigger, Row, TableBody, TableHeader, TableView, TabList, TabPanels, Tabs, ToastQueue, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { DeleteConfirmationDialog } from '../../finder/components/DeleteConfirmationDialog';
import { FPAData } from '../../../../infra/protected/FPA/FPAData';
import { useReefConfig } from '../../../../hooks/UseReefConfig';
import { getDownloadUrl } from '../../../../utils/ImagePathUtils';
import { useTranslation } from 'react-i18next';
import { statusColor } from '../../../../utils/helperUtil';
import { ListItemStatusRequest } from '../../../../services/soap/item/requests/ListItemStatusRequest';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Key } from '@react-types/shared';
import { Badge, Button } from 'react-bootstrap';
import ComponentRelations from './ComponentRelations';
import { useCategoryColors } from '../../../../hooks/useCategoryColors';
import { ProductStatusDropdown } from './ProductStatusDropdown';
interface IProductDetailViewProps {
  product: any;
  productStatusList: any[];
  onPrint?: (item: any) => void;
  onEdit?: (item: boolean) => void;
  onDelete?: (item: any) => void;
  onTool?: (item: any) => void;
  onAI?: (item: any) => void;
  onCopy?: (item: any) => void;
  onMove?: (item: any) => void;
  selectedItem?: any;
  handleBackClick?: () => void;
}
const ProductDetailView: React.FC<IProductDetailViewProps> = ({
  product,
  productStatusList,
  onPrint, onEdit, onDelete, onTool, onAI, selectedItem, onCopy, onMove, handleBackClick
}) => {
  const { contactSettings } = usePreloadAssets();
  const [employeesData, setEmployeesData] = useState<any>([]);
  const { store, itemService } = useDependency();
  const [result, setResult] = useState<any>([]);
  let [activityStatus, setActivityStatus] = useState('');const 
  { t } = useTranslation('products');
  const _t = (key: string) => t(`product_detail.${key}`, { ns: 'products' });
  const _tt = (key: string) => t(`product_common.${key}`, { ns: 'products' });
  const { getProductCategoryColor, getTextColor } = useCategoryColors();

  let [isOpen, setOpen] = React.useState(false);

  const { baseUrl, loginInfo } = useReefConfig();
  const getProfileUrl = () => {
    if (result.DOCUMENT && result.DOCUMENT.length > 0) {
      const imageUrl = getDownloadUrl(result.DOCUMENT[0].documentId, baseUrl, store.Server, store.SessionId);
      return imageUrl
    }
    return '/assets/images/avatar--desktop--light@2x.png'
  }


  function itemTemplate(data: any): JSX.Element {
    return (
      <Flex UNSAFE_className={styles.dot_text_container}>
        <View UNSAFE_className={styles.dot} UNSAFE_style={{ backgroundColor: `${data.color}` }}></View>
        <View marginTop={5}>{data.name}</View>
      </Flex>
    );
  }

  function valueTemplate(data: any): JSX.Element {
    return (
      <Flex UNSAFE_className={styles.dot_text_container}>
        <View UNSAFE_className={styles.dot} UNSAFE_style={{ backgroundColor: `${data.color}` }}></View>
        <View marginTop={5} UNSAFE_style={{ marginLeft: '10px' }}>
          <span title={data?.name}>{data?.name && data?.name.length > 16 ? data?.name.substring(0, 16) + '...' : data?.name}</span>
        </View>
      </Flex>
    );
  }

  async function updateActivityStatus(e: any) {
    // let resActivity = await projectService.updateActivity(new UpdateActivityRequest(store.Server, store.SessionId, { ...activityData, customState: e.value }));
    // let status = activityStatusList.find((status: any) => status.id === e.value);
    // if (resActivity.result == 'OK') {
    //   await featureService.checkWorkFlowQueue(new CheckWorkFlowQueueRequest(store.Server, store.SessionId));
    //   ToastQueue.positive(t('status_updated_successfully', { ns: 'layout_components' }), { timeout: 1000 });
    //   dispatch(setSelectedItem({ item: selectedItem ? { ...selectedItem, statusName: status.name, statusColor: statusColor(status.color) } : null, show_context: false }));
    // } else {
    //   ToastQueue.negative(resActivity.EXCEPTION?.message, { timeout: 1000 });
    // }
  }

  let menuItems = [
    { key: 'copy', name: _t('copy_link') },
    { key: 'move', name: _t('move') },
  ];

  const handlePrintClicked = () => {
    //console.log('handlePrintClicked');
    if (onPrint) {
      onPrint(product);
    }
  };

  const handleEditClicked = () => {
    if (onEdit) {
      onEdit(true);
    }
  };

  const handleDeleteClicked = () => {
    if (onDelete) {
      onDelete(product);
    }
  };

  const handleToolClicked = () => {
    if (onTool) {
      onTool(product);
    }
  };

  const handleAIClicked = () => {
    if (onAI) {
      onAI(product);
    }
  };

  const handleMenuClicked = (key: Key) => {
    if (key === 'copy') {
      copyUrl();
    } else if (key === 'move') {
      if (onMove) {
        onMove(product);
      }
    }
  };

  const componentData = Array.isArray(product.COMPONENT)
  ? product.COMPONENT
  : product.COMPONENT
    ? [product.COMPONENT]
    : [];

const uniqueComponents = Array.from(
  new Map(componentData.map((item:any) => [item.component, item])).values()
);

const copyUrl = () => {
    const url = `${window.location.origin}/products?id=${product?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(t('link_copied_to_clipboard', { ns: 'layout_components' }), { timeout: 1000 });
  }

  return (
    <Flex width="100%" direction={'column'}>
      <View UNSAFE_className={styles.header_main}>
        <View UNSAFE_className={styles.header_child}>
          <View UNSAFE_className={styles.frame_parent}>
            <View UNSAFE_className={styles.icon_activity_parent}>
              {handleBackClick &&
                  <ActionButton isQuiet onPress={handleBackClick} UNSAFE_className={styles.back_button}>
                    <ChevronLeft size={20} />
                  </ActionButton>
                }
              <ActivityIconBlue size={25} />
              <b title={product?.name} className={styles.activity_name}>
                {product?.name?.length > 55 ? product?.name.substring(0, 55) + '...' : product?.name}
              </b>
            </View>
            {product.manufacturerName &&
              <View UNSAFE_className={styles.folder_name_parent}>
                <View UNSAFE_className={styles.folder_name}>{`${product.manufacturerName}`}</View>
              </View>
            }
          </View>
          {(product.componentCategoryName || product?.refId || product.typeName) &&
            <View UNSAFE_className={styles.tag_parent} marginTop={'27px'}>
              {product?.typeName && (
                <Badge
                  key={'tag1'}
                  style={{ display: "div", alignItems: "center", }}
                  className={styles.greyBadge}
                >
                  <span >{product.typeName}</span>
                </Badge>
              )}
              {product?.refId && (
                <Badge
                  key={'tag2'}
                  style={{ display: "div", alignItems: "center", }}
                  className={styles.greyBadge}
                >
                  <span >{product.refId}</span>
                </Badge>
              )}
                              {product?.componentCategoryName && (
                  <Badge
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: getProductCategoryColor(product.componentCategoryName),
                      color: getTextColor(getProductCategoryColor(product.componentCategoryName)),
                    }}
                    bg=""
                    className={styles.purpleBadge}
                  >
                    <span>{product.componentCategoryName}</span>
                  </Badge>
                )}
            </View>
          }
        </View>
        <View UNSAFE_className={styles.icon_list_parent}>
          <ProductStatusDropdown productStatusArray={productStatusList} selectedStatus={product.status} onStatusChange={updateActivityStatus} />
          <View UNSAFE_className={styles.icon_list_child}>
            <div className={styles.atollon_icon} onClick={handleAIClicked}>
              <AIChatIcon2 size={32} />
            </div>
            <div className={styles.edit_icon} onClick={handleEditClicked}>
              <EditIcon size={32} />
            </div>
            <div className={styles.tool_icon} onClick={handleToolClicked}>
              <LockIcon size={32} />
            </div>
            <div className={styles.delete_icon} onClick={handleDeleteClicked}>
              <TrashIcon size={32} />
            </div>
            <MenuTrigger>
              <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
              <Menu items={menuItems} onAction={handleMenuClicked}>
                {item => <Item key={item.key}>{item.name}</Item>}
              </Menu>
            </MenuTrigger>
          </View>
        </View>
      </View>
      <View>
        <Tabs aria-label="Product detail" isEmphasized>
          <TabList>
            <Item key="product">{_t('product_details')}</Item>
          </TabList>
          <TabPanels>
            <Item key="product">
              <Flex direction={'row'} marginTop="size-400">
                <Flex direction="column" gap="size-100" gridArea="detail" width='60%'>
                  <View UNSAFE_className={styles.productMainTitle}>
                    {product.name}
                  </View>

                  <View>
                    <span className={styles.product_code_title}>{_t('product_code')}: </span>
                    <span className={styles.product_code}>{product.refId}</span>
                  </View>

                  <View marginTop="size-100">
                    <p className={styles.product_detail}>
                      {`${product.note && product.note.length > 0 ? product.note : ''}`}
                    </p>
                  </View>
                </Flex>

                <Flex alignItems="center" justifyContent="center" gridArea="image" width='40%'>
                  <div className={styles.img_gray_box}></div>
                </Flex>
              </Flex>
            </Item>
          </TabPanels>
        </Tabs>
      </View>
      <View marginTop={10} UNSAFE_className={styles.greybox_parent}>
        <Flex justifyContent="space-between" alignItems="center" UNSAFE_style={{ width: '100%' }}>
          <View UNSAFE_className={styles.value_header}><b>Prices</b></View>
          <Flex gap="size-100">
            <ActionButton isQuiet aria-label="Add">
              <Plus size={20} />
            </ActionButton>
          </Flex>
        </Flex>
        <View UNSAFE_className={styles.value_wrapper}>
          <View
            UNSAFE_style={{
              display: 'grid',
              gridTemplateColumns: '0.5fr 1fr',
              gap: '10px',
            }}
          >
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('purchasePrice')}:</div>
              <div className={styles.value}>{product.purchasePrice}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('price')}:</div>
              <div className={styles.value}>{product.amount}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('currency')}:</div>
              <div className={styles.value}>{product.currencyName}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('vat')}:</div>
              <div className={styles.value}>{product.vatValue}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('quantity')}:</div>
              <div className={styles.value}>{product.quantity}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('includingVat')}:</div>
              <div className={styles.value}>{product.amountWithVat}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('units')}:</div>
              <div className={styles.value}>{product.unitsName}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className={styles.value_title}>{_t('measureStocks')}:</div>
              <div className={styles.value}>{product.measureStock}</div>
            </div>
          </View>
        </View>
      </View>
      {/* <Flex maxHeight={{ base: '1000px', L: '450px', M: '450px' }} width="100%" direction="column" UNSAFE_style={{ overflowX: 'auto' }}>
            <TableView
              UNSAFE_className="tblLayoutComponent"
              aria-label="Billing Line"
              onSelectionChange={handleRowClick}
              selectionMode="single"
              selectedKeys={selectedKeys}
              selectionStyle="highlight"
              width={{ base: '100%', L: '100%', M: '100%' }}
              minHeight={'80px'}
              maxHeight={{ base: '1000px', L: '450px' }}
              marginBottom={'size-250'}
            >
              <TableHeader columns={isMobile ? columnsDataMobile : columnsData}>
                {column => (
                  <Column showDivider key={column.key} width={column?.width}>
                    {column.name}
                  </Column>
                )}
              </TableHeader>
              <TableBody items={rowsData}>{item => <Row>{columnKey => <Cell>{(item as any)[String(columnKey)]}</Cell>}</Row>}</TableBody>
            </TableView>
          </Flex> */}
      {componentData.length > 0 && (
        <>
          <View marginTop={10}>
            <ComponentRelations data={uniqueComponents || []} />
          </View>
        </>
      )
      }
    </Flex>
  );
};

export default ProductDetailView;
